import clsx from 'clsx';
import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap';
import iconDislike from "../../../assets/images/dislike-icon.png";

const MalusPopover = React.forwardRef(
    ({ popper, children, show: _, ...props }, ref) => {
      const [selectedBM, setSelectedBM] = useState(props?.selectionOption ? props?.selectionOption : []);
      useEffect(() => {
        popper.scheduleUpdate();
      
      }, [children, popper]);

      function isObjEmpty(obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) return false;
        }
      
        return true;
      }
      
      const  addBonus = (item) => {
       
        if(!isObjEmpty(item)){
        setSelectedBM([...selectedBM, { id: item.id, BM: item.name }]);
        props.getSelectionOption(item);
        selectedBM.forEach((element) => {
         
          if (element.id === item.id) {
            setSelectedBM(
              selectedBM.filter((element) => element?.id !== item.id)
            );
          }
        });}
      };
      return (
        <Popover ref={ref} body {...props}>
          {children.map((item, i) => (
            <div
              key={i}
              onClick={() => {          
                if(props.isDisabled) return;
                addBonus(item)
              }
              }
              className={clsx("container-bonus-malus-eval", {
                "container-bonus-malus-on":
                  Object.values(selectedBM)?.filter(
                    (element) => element?.id === item.id
                  ).length > 0,
                "container-bonus-malus-off":
                  Object.values(selectedBM)?.filter(
                    (element) => element?.id === item.id
                  ).length === 0 && item.id === null,
              })}
            >
              {item.name}
              <div
                className={clsx({
                  "icon-bonus-malus-on":
                    Object.values(selectedBM)?.filter(
                      (element) => element?.id === item.id
                    ).length > 0,
                  "icon-bonus-malus-off":
                    Object.values(selectedBM)?.filter(
                      (element) => element?.id === item.id
                    ).length === 0 || item.id === null,
                })}
              ></div>
            </div>
          ))}
        </Popover>
      );
    }
  );
const Popovermalus = (props) => {
  return (
    <OverlayTrigger
    trigger={"click"}
    rootClose
   placement="bottom-end"
   overlay={
     <MalusPopover
       id="popover-contained"
       className="popup-like-dislike"
       getSelectionOption={props.getSelectionOption}
       selectionOption={props.selectionOption}
       isDisabled={props.isDisabled}
     >
        {props.val}
     </MalusPopover>
   }
 >
   <img
     className="img-chat-position"
     width={20}
     src={iconDislike}
   />
 </OverlayTrigger>
  )
}

export default Popovermalus